export const BookmarkClientInterface = {
  get: function () {},
  getOne: function (id) {},
  update: function (id) {},
  delete: function (id) {},
  create: function (data) {},
};
